import {
  selectAuthDialogOpen,
  selectAuthPreventClose,
  selectLastUsedProvider,
} from "@/lib/storage/auth-slice"
import { closeAuthDialog } from "@/lib/storage/auth-thunks"
import { useAppDispatch, useAppSelector } from "@/lib/storage/hooks"
import AuthFlow from "@/components/auth/auth-flow"
import {
  blockImplicitDismiss,
  Dialog,
  DialogBody,
  DialogContent,
} from "@/components/ui/dialog"

export function AuthDialog() {
  const dispatch = useAppDispatch()
  const open = useAppSelector(selectAuthDialogOpen)
  const preventClose = useAppSelector(selectAuthPreventClose)
  const lastUsedProvider = useAppSelector(selectLastUsedProvider)
  // The first step autofocuses its field when the user signed in with it
  // last time, so summon the iOS keyboard during the tap that opens the
  // dialog and hand it to that field once the drawer has settled.
  const summonKeyboard =
    lastUsedProvider === "email" || lastUsedProvider === "phone"

  // const handleClose = async () => {
  //   // since we override the onCloseAutoFocus(), we need to make sure to call Redux that we close the dialog
  //   dispatch(setDialogClosed())
  // }

  return (
    <Dialog
      analyticsName="Auth"
      analyticsEnabled={false}
      open={open}
      summonKeyboard={summonKeyboard}
      onOpenChange={(newOpen, event) => {
        if (preventClose && blockImplicitDismiss(newOpen, event)) {
          return
        }
        if (!newOpen) {
          void dispatch(closeAuthDialog())
        }
      }}
    >
      <DialogContent hideClose={preventClose}>
        <DialogBody className="sm:pt-16">
          {open && <AuthFlow surface="dialog" />}
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
